<template>
  <div class="mypage-point-expiration-date-pane">
    <div class="mypage-point-expiration-date-pane__container">
      <p class="mypage-point-expiration-date-pane__message">
        {{ $tc('MypagePage.MypagePointExpirationDatePage.description') }}
      </p>

      <div class="mypage-point-expiration-date-pane__table">
        <mypage-point-expiration-date-table-section
          :userPointsWithExpirationByExpirationDate="userPointsWithExpirationByExpirationDate"
        />
      </div>

      <ul class="mypage-point-expiration-date-pane__buttons">
        <li class="mypage-point-expiration-date-pane__button" v-if="isIncludeNextRelease">
          <atom-router-button
            to="/mypage/point-history"
            :linkText="$tc('MypagePage.MypagePointExpirationDatePage.buttonLabel.history')"
            theme="light"
            colorType="secondary"
          />
        </li>
        <li class="mypage-point-expiration-date-pane__button">
          <atom-icon-link-button
            :url="pointDescriptionPageUrl"
            :linkText="$tc('MypagePage.MypagePointExpirationDatePage.buttonLabel.detail')"
            theme="light"
            colorType="tertiary"
            :imgPath="require('@/assets/img/icon/icon_external_link_gray75.svg')"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MypagePointExpirationDateTableSection from '@/components/MypagePointExpirationDatePage/MypagePointExpirationDatePane/MypagePointExpirationDateTableSection.vue'
import AtomIconLinkButton from '@/components/atoms/AtomIconLinkButton.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'
import StoreUtil from '@/store/StoreUtil'
import I18n from '@/locales/I18n'
import Const from '@/util/Const'

export default defineComponent({
  name: 'MypagePointExpirationDatePane',
  components: {
    AtomRouterButton,
    AtomIconLinkButton,
    MypagePointExpirationDateTableSection,
  },
  setup() {
    // TODO: ポイント獲得履歴表示対応時に消す
    const isIncludeNextRelease = process.env.VUE_APP_INCLUDE_NEXT_RELEASE === 'true'

    const mypagePointExpirationDatePageStore = StoreUtil.useStore('MypagePageStore')
    const { userPointsWithExpirationByExpirationDate } = mypagePointExpirationDatePageStore

    const pointDescriptionPageUrl =
      I18n.locale === 'ja'
        ? Const.EXTERNAL_LINKS.ABOUT_MEMBER_RANK.JA
        : Const.EXTERNAL_LINKS.ABOUT_MEMBER_RANK.EN

    return {
      isIncludeNextRelease,
      pointDescriptionPageUrl,
      userPointsWithExpirationByExpirationDate,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-point-expiration-date-pane {
  height: 100%;
  overflow-y: auto;

  &__container {
    max-width: 800px;
    padding: 24px 16px;
    margin: 0 auto;

    @media screen and (min-width: $responsiveTabletWidth) {
      margin-top: 46px;
    }
  }

  &__message {
    font-size: 13px;
    font-weight: 500;
    color: $black20;

    @media screen and (min-width: $responsiveTabletWidth) {
      color: $gray75;
    }
  }

  &__table {
    margin-top: 24px;
  }

  &__buttons {
    margin-top: 24px;
  }

  &__button {
    max-width: 347px;
    margin: 0 auto;

    + .mypage-point-expiration-date-pane__button {
      margin-top: 24px;
    }

    ::v-deep {
      img {
        width: 12px;
        height: 12px;
        opacity: 0.8;
      }

      span {
        white-space: pre-wrap;
      }
    }
  }
}
</style>
